export default __webpack_public_path__ + "static/media/placeholder.c6aa2328.svg";